var _defs, _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4Orange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 197.37 197.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f58220;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m70.95,146.09c-1.01,0-2.03-.3-2.92-.91-2.35-1.62-2.94-4.83-1.32-7.18,6.74-9.78,18.53-15.68,31.56-15.78,13.21-.08,25.3,5.78,32.37,15.72,1.65,2.32,1.11,5.55-1.22,7.2-2.32,1.65-5.55,1.11-7.2-1.22-5.11-7.2-14.07-11.46-23.88-11.38-9.66.07-18.31,4.3-23.13,11.31-1,1.45-2.61,2.23-4.26,2.23Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 62.4,
    cy: 78.34,
    r: 11.53,
    transform: "translate(-2.29 1.88) rotate(-1.69)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 134.97,
    cy: 78.34,
    r: 11.53
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m98.69,197.37C44.27,197.37,0,153.1,0,98.69S44.27,0,98.69,0s98.69,44.27,98.69,98.69-44.27,98.69-98.69,98.69Zm0-187.05C49.96,10.32,10.32,49.96,10.32,98.69s39.64,88.36,88.36,88.36,88.36-39.64,88.36-88.36S147.41,10.32,98.69,10.32Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Orange);
export default __webpack_public_path__ + "static/media/4Orange.ff64e1e06da8037d94a5e70bf69842d5.svg";
export { ForwardRef as ReactComponent };